import styled from "styled-components/macro";


export const ImgHr = styled.img`
  grid-area: hr;
  
`;